export const snakeToCamel = str => {
  return str.toLowerCase().replace(/([-_]\w)/g, g => g[1].toUpperCase());
}

export const toPascalCase = str => {
  let camelCase = snakeToCamel(str);
  let pascalCase = camelCase[0].toUpperCase() + camelCase.substr(1);
  return pascalCase;
}

export const toUnderscoreUpperCase = str => {
  return toUnderscoreCase(str).toUpperCase();
}

export const toUnderscoreCase = str => {
  return str.replace(/\.?([A-Z]+)/g, (x, y) => {
    return "_" + y.toLowerCase()
  }).replace(/^_/, "");
}

export const hexToRGB = (hex, alpha) => {
  // console.log('HEX', hex);
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}

export const toDecimal = (price, decimalPlaces) => {
  const priceString = price.toString();
  // console.log('PRICE_STRING', priceString);
  const pointIndex = priceString.indexOf('.');
  // Return the integer part if decimalPlaces is 0
  if (decimalPlaces === 0) {
    return priceString.substr(0, pointIndex);
  }

  // Return value with 0s appended after decimal if the price is an integer
  if (pointIndex === -1) {
    const padZeroString = '0'.repeat(decimalPlaces);

    return `${priceString}.${padZeroString}`;
  }

  // If numbers after decimal are less than decimalPlaces, append with 0s
  const padZeroLen = priceString.length - pointIndex - 1;
  if (padZeroLen > 0 && padZeroLen < decimalPlaces) {
    const padZeroString = '0'.repeat(padZeroLen);

    return `${priceString}${padZeroString}`;
  }

  return priceString.substr(0, pointIndex + decimalPlaces + 1);
};
export const toDecimalWithComma = (price, decimalPlaces) => {
  const priceString = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // console.log('PRICE_STRING', priceString);
  const pointIndex = priceString.indexOf('.');
  // Return the integer part if decimalPlaces is 0
  if (decimalPlaces === 0) {
    return priceString.substr(0, pointIndex);
  }

  // Return value with 0s appended after decimal if the price is an integer
  if (pointIndex === -1) {
    const padZeroString = '0'.repeat(decimalPlaces);

    return `${priceString}.${padZeroString}`;
  }

  // If numbers after decimal are less than decimalPlaces, append with 0s
  const padZeroLen = priceString.length - pointIndex - 1;
  if (padZeroLen > 0 && padZeroLen < decimalPlaces) {
    const padZeroString = '0'.repeat(padZeroLen);

    return `${priceString}${padZeroString}`;
  }

  return priceString.substr(0, pointIndex + decimalPlaces + 1);
};

export const toDecimalWithCommaNew = (price, decimalPlaces) => {
  let priceString = price.toString();
  if (priceString.indexOf('.') >= 0) {
    const lastPart = priceString.substr(priceString.indexOf('.'));
    const firstPart = priceString.substr(0, priceString.indexOf('.'));
    priceString = firstPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    priceString = `${priceString}${lastPart}`;
  } else {
    priceString = priceString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const pointIndex = priceString.indexOf('.');
  // Return the integer part if decimalPlaces is 0
  if (decimalPlaces === 0) {
    return priceString.substr(0, pointIndex);
  }

  // Return value with 0s appended after decimal if the price is an integer
  if (pointIndex === -1) {
    const padZeroString = '0'.repeat(decimalPlaces);

    return `${priceString}.${padZeroString}`;
  }

  // If numbers after decimal are less than decimalPlaces, append with 0s
  const padZeroLen = (priceString.length - pointIndex) - 1;
  if (padZeroLen > 0 && padZeroLen < decimalPlaces) {
    const padZeroString = '0'.repeat(padZeroLen);

    return `${priceString}${padZeroString}`;
  }

  return priceString.substr(0, pointIndex + decimalPlaces + 1);
};

export const fetchCurrencySymbol = curr => {
  switch (curr) {
    case 'PHP':
      return '₱';
    case 'USD':
      return '$';
    default:
      return '₱';
  }
};

export const generateRandomString = (length) => {
  let id = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  for (let i = 0; i < length; i++) {
    id += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return id;
};

export const decodeData = (values) => {
  const sequence = ["U", "D", "T", "Q", "C"];

  const sortedValues = Object.entries(values)
    .sort((a, b) => {
      const indexA = a[0].replace("REACT_APP_", "")[1];
      const indexB = b[0].replace("REACT_APP_", "")[1];
      return sequence.indexOf(indexA) - sequence.indexOf(indexB);
    })
    .map(([_, value]) => value)
    .join("");

  const decodedValues = atob(sortedValues).split(":");

  return {
    host1: decodedValues[0],
    host2: decodedValues[1],
    protocol: decodedValues[2],
    port: decodedValues[3],
    username: decodedValues[4],
    password: decodedValues[5],
  };
};
